'use client';

import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card } from "reactstrap";
import { Breadcrumbs } from "../../AbstractElements";
import { useForm } from "react-hook-form";
import { Pencil, AlertCircle, Building2, MapPin, DollarSign, User } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { useLoader } from "../../_helper/LoaderContext";
import { toast } from "react-toastify";
import { useLab } from "../../_helper/PharmacyProvider";
import { Tooltip } from "react-tooltip";
import { addLabUser, generate } from "./service/user-service";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { Controller } from "react-hook-form";
import { cityMaster, districtMaster, pincodeMaster, stateMaster } from "../LabProfile/service/profile-service";
import { useTranslation } from "react-i18next";

export default function AddUser() {
    const { t } = useTranslation();
    const [profileImage, setProfileImage] = useState(null); // Base64 preview
    const [profileImageFile, setProfileImageFile] = useState(null);
    const [imageError, setImageError] = useState("");
    const { currentLab } = useLab()
    const { setLoading } = useLoader();
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        country: "IN",
        state: "",
        district: "",
        city: "",
        pincode: ""
    });
    const {
        register,
        handleSubmit,
        formState: { errors, isSubmitting },
        setValue,
        trigger,
        control
    } = useForm();

    useEffect(() => {

    }, [])


    const handleImageUpload = (e) => {
        const file = e.target.files?.[0];
        if (!file) return;

        if (file.size > 5 * 1024 * 1024) {
            setImageError(t("File size must be less than 5MB"));
            return;
        }

        if (!["image/jpeg", "image/jpg", "image/png", "image/gif"].includes(file.type)) {
            setImageError(t("Only JPG, PNG, or GIF files are allowed"));
            return;
        }

        setImageError("");
        setProfileImageFile(file);

        const reader = new FileReader();
        reader.onloadend = () => {
            setProfileImage(reader.result);
        };
        reader.readAsDataURL(file);
    };

    const onSubmit = async (data) => {
        setLoading(true);
        try {
            const form_Data = new FormData();
            form_Data.append("first_name", data.firstName);
            form_Data.append("last_name", data.lastName);
            form_Data.append("facility_name", currentLab.facility_name);
            form_Data.append("email", currentLab.email);
            form_Data.append("contact_email", data.email);
            form_Data.append("password", data.password);
            form_Data.append("mobile", data.mobile);
            form_Data.append("address", currentLab?.contact_person.address);
            form_Data.append("createdById", currentLab?._id);
            form_Data.append("labId", currentLab?._id);
            form_Data.append("country", currentLab?.contact_person.country);
            form_Data.append("state", currentLab?.contact_person.state);
            form_Data.append("city", currentLab?.contact_person.city);
            form_Data.append("district", currentLab?.contact_person.district);
            if (profileImageFile) {
                form_Data.append("profilePicture", profileImageFile);
            }
            const res = await addLabUser(form_Data)
            if (res.data.success == true) {
                toast.success(res.data.message);
                navigate(`${process.env.PUBLIC_URL}/user`)
            }
        } catch (error) {
            // toast.warning("Failed to add user");
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const generetPassword = async () => {
        setLoading(true);
        try {
            const res = await generate();
            // console.log(res)
            if (res.data.success == true) {
                const generatedPassword = res.data.data.password;
                setValue("password", generatedPassword);
                // trigger("password");
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false)
        }
    }

    return (
        <>
            <Breadcrumbs mainTitle={t("Add User")} parent={t("Home")} subParent={t("List Of User")} title={t("Add User")} />
            <Container fluid={true}>
                <Row>
                    <Col>
                        <Card className="tw-shadow-sm tw-rounded-xl tw-border-0 tw-bg-white tw-p-4 md:tw-p-6">
                            <form className="tw-space-y-4" onSubmit={handleSubmit(onSubmit)}>
                                {/* Form Fields: Responsive Grid First */}
                                {/* Desktop: 3 columns | Tablet: 2 columns | Mobile: 1 column */}
                                <div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-3.5">
                                    <div>
                                        <label className="tw-block tw-font-medium tw-text-sm tw-mb-1">{t("First Name")} <span className="tw-text-red-500">*</span></label>
                                        <input type="text" className="form-control" placeholder={t("Enter first name")} {...register("firstName", { required: t("First name is required") })} />
                                        {errors.firstName && <p className="tw-text-red-500 tw-text-xs tw-mt-1">{errors.firstName.message}</p>}
                                    </div>
                                    <div>
                                        <label className="tw-block tw-font-medium tw-text-sm tw-mb-1">{t("Last Name")} <span className="tw-text-red-500">*</span></label>
                                        <input type="text" className="form-control" placeholder={t("Enter last name")} {...register("lastName", { required: t("Last name is required") })} />
                                        {errors.lastName && <p className="tw-text-red-500 tw-text-xs tw-mt-1">{errors.lastName.message}</p>}
                                    </div>
                                    <div className="sm:tw-col-span-2 lg:tw-col-span-1">
                                        <label className="tw-block tw-font-medium tw-text-sm tw-mb-1">{t("Email")} <span className="tw-text-red-500">*</span></label>
                                        <input type="email" className="form-control" placeholder={t("Enter email")} {...register("email", { required: t("Email is required"), pattern: { value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, message: t("Invalid email") } })} />
                                        {errors.email && <p className="tw-text-red-500 tw-text-xs tw-mt-1">{errors.email.message}</p>}
                                    </div>
                                </div>

                                {/* Followed by 2 columns */}
                                <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-3.5">
                                    <div>
                                        <label className="tw-block tw-font-medium tw-text-sm tw-mb-1">{t("Mobile Number")} <span className="tw-text-red-500">*</span></label>
                                        <Controller
                                            name="mobile"
                                            control={control}
                                            rules={{ required: t("Mobile is required") }}
                                            render={({ field }) => (
                                                <PhoneInput {...field} country="in" enableSearch placeholder="+91 9876543210" inputClass="form-control" inputStyle={{ width: "100%" }} onChange={(value) => field.onChange(value)} />
                                            )}
                                        />
                                        {errors.mobile && <p className="tw-text-red-500 tw-text-xs tw-mt-1">{errors.mobile.message}</p>}
                                    </div>
                                    <div>
                                        <label className="tw-block tw-font-medium tw-text-sm tw-mb-1">{t("Password")} <span className="tw-text-red-500">*</span></label>
                                        <div className="input-group">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder={t("Enter Password")}
                                                {...register("password", { required: t("Password is required") })}
                                            />
                                            <span className="input-group-text tw-cursor-pointer" onClick={generetPassword} data-tooltip-id="generate">
                                                <i className="bi bi-lock-fill"></i>
                                            </span>
                                            <Tooltip id="generate" place="top" content={t("Auto Generate Password")} />
                                        </div>
                                        {errors.password && <p className="tw-text-red-500 tw-text-xs tw-mt-1">{errors.password.message}</p>}
                                    </div>
                                </div>

                                {/* Followed by 1 column where appropriate */}
                                {formData.country === "OTHER" && (
                                    <div className="tw-grid tw-grid-cols-1 tw-gap-3.5">
                                        <div>
                                            <label className="tw-block tw-font-medium tw-text-sm tw-mb-1">{t("Country Name")}</label>
                                            <input type="text" className="form-control" placeholder={t("Enter country")} {...register("country")} />
                                        </div>
                                    </div>
                                )}

                                {/* Dedicated Section Below Inputs: Profile Image & Laboratory Info side by side */}
                                <div className="tw-pt-3.5 tw-border-t tw-border-gray-200">
                                    <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4 tw-items-center">
                                        {/* Profile Image - Moderately Sized */}
                                        <div className="tw-flex tw-items-center tw-gap-4">
                                            <div className="tw-relative tw-flex-shrink-0">
                                                <label htmlFor="profile-upload" className="tw-cursor-pointer tw-block tw-m-0">
                                                    <div className="tw-w-24 tw-h-24 tw-rounded-full tw-overflow-hidden tw-bg-gray-100 tw-border-2 tw-border-dashed tw-border-gray-300 tw-flex tw-items-center tw-justify-center hover:tw-border-primary tw-transition-all">
                                                        {profileImage ? (
                                                            <img src={profileImage} alt={t("Profile")} className="tw-w-full tw-h-full tw-object-cover" />
                                                        ) : (
                                                            <User className="tw-w-10 tw-h-10 tw-text-gray-400" />
                                                        )}
                                                    </div>
                                                </label>
                                                <label htmlFor="profile-upload" className="tw-absolute tw-bottom-0.5 tw-right-0.5 bg-primary tw-rounded-full tw-p-1.5 tw-shadow-sm tw-cursor-pointer tw-flex tw-items-center tw-justify-center tw-w-7 tw-h-7 tw-border-2 tw-border-white tw-m-0">
                                                    <Pencil className="tw-w-3.5 tw-h-3.5 tw-text-white" />
                                                </label>
                                                <input id="profile-upload" type="file" accept="image/jpeg,image/jpg,image/png,image/gif" onChange={handleImageUpload} className="tw-hidden" />
                                            </div>
                                            <div>
                                                <label htmlFor="profile-upload" className="tw-cursor-pointer tw-block tw-font-semibold tw-text-sm tw-text-gray-800 tw-mb-0.5">
                                                    {t("Profile Picture")}
                                                </label>
                                                <p className="tw-text-gray-500 tw-text-xs tw-mb-0">{t("JPG, PNG or GIF (max 5MB)")}</p>
                                                {imageError && (
                                                    <div className="tw-flex tw-items-center tw-gap-1 tw-text-red-600 tw-text-xs tw-mt-1">
                                                        <AlertCircle className="tw-w-3.5 tw-h-3.5 tw-flex-shrink-0" />
                                                        <span>{imageError}</span>
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        {/* Laboratory Info */}
                                        <div className="tw-w-full tw-rounded-lg tw-p-3 tw-px-3.5 tw-bg-gray-50/70" style={{ border: "1px solid #1b255b" }}>
                                            <div className="tw-font-semibold tw-text-xs tw-text-gray-700 tw-mb-2 tw-flex tw-items-center tw-gap-1.5">
                                                <Building2 className="tw-w-3.5 tw-h-3.5" />
                                                {t("Laboratory Info")}
                                            </div>
                                            <div className="tw-space-y-1.5 tw-text-xs">
                                                <div className="tw-flex tw-justify-between">
                                                    <span className="tw-text-gray-600">{t("Lab Name")}:</span>
                                                    <span className="tw-font-medium tw-text-gray-900">{currentLab?.facility_name}</span>
                                                </div>
                                                <div className="tw-flex tw-justify-between tw-items-center">
                                                    <span className="tw-text-gray-600">{t("Base Currency")}:</span>
                                                    <span className="tw-font-bold tw-text-primary">{currentLab?.baseCurrency}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Submit Buttons */}
                                <div className="tw-flex tw-justify-end tw-gap-3 tw-pt-2">
                                    <button type="submit" disabled={isSubmitting} className="btn btn-primary tw-px-6">
                                        {isSubmitting ? t("Saving...") : t("Add User")}
                                    </button>
                                    <Link to={`${process.env.PUBLIC_URL}/user`}>
                                        <button type="button" className="btn btn-secondary">{t("Cancel")}</button>
                                    </Link>
                                </div>
                            </form>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
}